<div class="flex flex-col gap-4 w-full h-full p-5 bg-white overflow-y-auto">
    <div class="flex items-center justify-between">
        <span class="text-lg font-semibold text-gray-800">Filters</span>
        <button (click)="closeDialog()"
            class="bg-white outline-none border-none !bg-transparent hover:bg-gray-50 text-gray-400 hover:text-gray-600 !w-8 !h-8 !rounded-md cursor-pointer">
            <span class="material-symbols-outlined !text-lg">close</span>
        </button>
    </div>

    <div class="flex items-center justify-between gap-5">
        <span class="text-gray-600 text-base">Type</span>
        <div class="w-max flex items-center gap-0.5 bg-[#d1d5db38] rounded-lg p-1">
            <button (click)="setTab('all')"
                [ngClass]="tab === 'all' ? 'bg-white text-primary shadow-sm' : 'bg-transparent'"
                class="flex items-center gap-0.5 extra-small:gap-1 sm:gap-1 px-1 extra-small:px-2 sm:px-2 py-0.5 extra-small:py-1 sm:py-1 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-[30px] extra-small:!h-[35px] sm:!h-[35px] cursor-pointer">
                <span class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">layers</span>
                <span class="inline text-sm">All</span>
            </button>
            <button (click)="setTab('app')"
                [ngClass]="tab === 'app' ? 'bg-white text-primary shadow-sm' : 'bg-transparent'"
                class="flex items-center gap-0.5 extra-small:gap-1 sm:gap-1 px-1 extra-small:px-2 sm:px-2 py-0.5 extra-small:py-1 sm:py-1 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-[30px] extra-small:!h-[35px] sm:!h-[35px] cursor-pointer">
                <span class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">tab</span>
                <span class="inline text-sm">App</span>
            </button>
            <button (click)="setTab('website')"
                [ngClass]="tab === 'website' ? 'bg-white text-primary shadow-sm' : 'bg-transparent'"
                class="flex items-center gap-0.5 extra-small:gap-1 sm:gap-1 px-1 extra-small:px-2 sm:px-2 py-0.5 extra-small:py-1 sm:py-1 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-[30px] extra-small:!h-[35px] sm:!h-[35px] cursor-pointer">
                <span class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">public</span>
                <span class="inline text-sm">Website</span>
            </button>
        </div>
    </div>

    <!-- Date Range Dropdown -->
    <div class="flex items-center justify-between gap-5 relative">
        <span class="text-gray-600 text-base">Date Range</span>
        <button (click)="openCalendarDropDown()" date-dropdown-btn #dateRangeButton
            class="flex items-center justify-between gap-0.5 extra-small:gap-1 sm:gap-1 bg-white rounded-md px-2 extra-small:px-3 sm:px-3 py-0.5 extra-small:py-1 sm:py-1 text-xs extra-small:text-sm sm:text-sm font-medium border cursor-pointer border-solid border-[#5459D1] outline-none text-[#5459D1] hover:bg-[#5459D1] hover:text-white transition-colors">
            <span
                class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px] relative mr-1">calendar_month</span>
            <span class="inline text-sm relative">{{ selectedFilterLabel }}</span>
            <span
                class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">expand_more</span>
        </button>

        <!-- Custom Dropdown for Filter Presets (with date range) -->
        <div *ngIf="isOpenDateDropdown" date-dropdown #dateRangeDropdown
            class="custom-shadow absolute right-0 top-full mt-1 bg-white p-2 rounded-lg border border-gray-200 z-50 w-auto">
            <div class="flex flex-col gap-2 extra-small:gap-3 sm:gap-3 md:gap-4">
                <mat-form-field appearance="outline">
                    <mat-date-range-input [rangePicker]="picker" [formGroup]="selectedDateRange" [min]="minDate"
                        [max]="maxDate">
                        <input matStartDate placeholder="Start date" readonly formControlName="start">
                        <input matEndDate placeholder="End date" readonly class="!ml-2" formControlName="end">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix class="custom-icon" [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <div class="w-full">
                    <div class="text-xs text-gray-500 mb-1 capitalize extra-small:mb-2 sm:mb-2 font-semibold">Preset
                        Filters
                    </div>
                    <div class="flex flex-col">
                        <button *ngFor="let filter of presetFilters" (click)="setDateRange(filter)"
                            class="block px-2 py-[10px] text-xs extra-small:text-sm sm:text-sm text-left rounded transition-colors bg-white hover:bg-gray-50 no-underline cursor-pointer text-black focus-within:!bg-[#eef2ff] focus-within:!text-[#5459D1] font-medium border-none outline-none">
                            {{ filter.label }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex flex-col gap-2">
        <div class="flex items-center gap-1">
            <span class="text-gray-600 text-base">Compare period</span>
            <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                matTooltip="Show deltas vs a reference period (Productivity Trends and related reports).">info</span>
        </div>
        <div class="flex flex-wrap gap-1 bg-[#d1d5db38] rounded-lg p-1">
            <button *ngFor="let opt of comparePeriodOptions" type="button" (click)="setCompareWith(opt.value)"
                [ngClass]="selectedCompareWith === opt.value ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                class="flex-1 min-w-[calc(50%-4px)] flex items-center justify-center px-2 py-1.5 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-auto cursor-pointer">
                {{ opt.label }}
            </button>
        </div>
    </div>

    <hr class="m-0 border-[0.6px] border-[#e6e6e63b]">

    <div class="flex flex-col gap-1">
        <div class="flex items-center justify-between">
            <span class="text-gray-600 text-base">Filter By</span>
            <div class="flex items-center gap-0.5 bg-[#d1d5db38] rounded-lg p-1">
                <button (click)="selectMode('employee')"
                    [ngClass]="employeeTeamTab === 'employee' ? 'bg-white text-primary shadow-sm' : 'bg-transparent'"
                    class="flex items-center gap-0.5 extra-small:gap-1 sm:gap-1 px-1 extra-small:px-2 sm:px-2 py-0.5 extra-small:py-1 sm:py-1 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-[30px] extra-small:!h-[35px] sm:!h-[35px] cursor-pointer">
                    <span
                        class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">person</span>
                    <span class="inline text-sm">Employee</span>
                </button>
                <button (click)="selectMode('team')"
                    [ngClass]="employeeTeamTab === 'team' ? 'bg-white text-primary shadow-sm' : 'bg-transparent'"
                    class="flex items-center gap-0.5 extra-small:gap-1 sm:gap-1 px-1 extra-small:px-2 sm:px-2 py-0.5 extra-small:py-1 sm:py-1 rounded-md text-xs extra-small:text-sm sm:text-sm font-medium transition-colors focus:outline-none border-none !h-[30px] extra-small:!h-[35px] sm:!h-[35px] cursor-pointer">
                    <span
                        class="material-symbols-outlined text-[16px] extra-small:text-[18px] sm:text-[18px]">people</span>
                    <span class="inline text-sm">Team</span>
                </button>
            </div>
        </div>

        <!-- Employee search component -->
        <app-employee-search [userList]="usersList"
            [placeholder]="employeeTeamTab == 'employee' ? 'Search Employee' : 'Search Team'" [isNeedUserReturn]="true"
            class="!w-full !h-[40px]" [isInputSearch]="true" [selectedEmployeeId]=""
            (searchEmployeeName)="searchTimelineData($event)">
        </app-employee-search>

        <!-- employee and team selection -->
        <div class="w-full max-h-44 overflow-y-auto mt-[14px]"
            *ngIf="!loading && employeeTeamTab == 'employee' && filteredEmployeeList?.length > 0">
            <div *ngFor="let user of filteredEmployeeList"
                class="flex items-center justify-between py-2 px-3 rounded hover:bg-gray-50 cursor-pointer"
                (click)="toggleEmployeeSelection(user)" [ngClass]="employeeCheckboxMap[user?.id] ? 'bg-gray-100' : ''">
                <div class="flex items-start gap-3">
                    <div class="profile-image-container">
                        <img [src]="user?.meta?.profile_image_url" class="profile-image"
                            *ngIf="user?.meta?.profile_image_url && user?.meta?.profile_image_url !== 'null' && user?.meta?.profile_image_url !== null"
                            alt="Contact Person" />
                        <ngx-avatars
                            *ngIf="!user?.meta?.profile_image_url || user?.meta?.profile_image_url === 'null' || user?.meta?.profile_image_url === null"
                            name="{{ user?.name }}" [initialsSize]="2" [size]="32"></ngx-avatars>
                    </div>
                    <span class="text-base text-gray-700 capitalize">{{ user.name }}</span>
                </div>
                <!-- checkbox for multi-select -->
                <input type="checkbox" class="!h-[17px] !w-[17px] !text-[#5459D1] !relative !opacity-100"
                    [checked]="employeeCheckboxMap[user?.id]"
                    (change)="toggleEmployeeSelection(user); $event.stopPropagation();" />
            </div>
        </div>

        <div class="w-full max-h-44 overflow-y-auto mt-[14px]" *ngIf="loading">
            <div *ngFor="let num of [].constructor(5); let i = index">
                <div class="flex items-center gap-3 py-2 px-3 rounded hover:bg-gray-50 cursor-pointer">
                    <ngx-skeleton-loader class="skeleton-avatar"
                        [theme]="{ 'border-radius': '999px', height: '32px', width: '32px' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader class="skeleton-avatar"
                        [theme]="{ 'border-radius': '4px', height: '12px', width: '140px' }"></ngx-skeleton-loader>
                </div>
            </div>
        </div>

        <div class="w-full max-h-44 overflow-y-auto mt-[14px]"
            *ngIf="!loading && employeeTeamTab == 'team' && filteredTeamList?.length > 0">
            <div *ngFor="let team of filteredTeamList"
                class="flex items-center justify-between py-2 px-3 rounded hover:bg-gray-50 cursor-pointer"
                (click)="toggleTeamSelection(team)"
                [ngClass]="teamCheckboxMap[team?.id] ? 'bg-[#eef2ff] text-[#5459D1]' : 'text-gray-700'">
                <div class="flex items-center gap-3">
                    <div class="profile-image-container">
                        <ngx-avatars name="{{ team.title.rendered }}" [initialsSize]="2" *ngIf="team.title.rendered"
                            size="32"></ngx-avatars>
                    </div>
                    <span class="text-base capitalize font-medium">{{ team?.title?.rendered }}</span>
                </div>
                <!-- checkbox for single-select (optional check icon) -->
                <span class="material-symbols-outlined text-[18px]" *ngIf="teamCheckboxMap[team?.id]">check</span>
            </div>
        </div>

        <!-- Employee/Team selection section -->
        <div class="w-full" *ngIf="!loading && employeeTeamTab == 'employee' && filteredEmployeeList?.length == 0">
            <p class="text-xs text-gray-500 text-center">No employees found</p>
        </div>

        <div class="w-full" *ngIf="!loading && employeeTeamTab == 'team' && filteredTeamList?.length == 0">
            <p class="text-xs text-gray-500 text-center">No teams found</p>
        </div>
    </div>

    <hr class="m-0 border-[0.6px] border-[#e6e6e63b]">
    <div class="flex items-center justify-between gap-5 relative">
        <div class="flex items-center gap-1">
            <span class="text-gray-600 text-base">Shift</span>
            <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                matTooltip="Select a shift to auto-populate time, day, and work interpretation settings.">info</span>
        </div>
        <div class="relative w-40">
            <button (click)="toggleShiftDropdown()"
                class="w-full px-3 py-2 rounded-md border border-[#5459D1] bg-white text-sm text-[#5459D1] flex items-center justify-between transition-colors cursor-pointer">
                <span class="text-sm relative">{{ selectedShift?.shift_name || 'Select Shift' }}</span>
                <span class="material-symbols-outlined text-[16px]">expand_more</span>
            </button>
            <div *ngIf="isShiftDropdownOpen"
                class="absolute !w-auto !min-w-40 !h-auto top-full right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-10 overflow-hidden"
                (click)="$event.stopPropagation()">
                <!-- None Option -->
                <button (click)="selectShift(null); $event.stopPropagation()"
                    [ngClass]="selectedShift === null ? 'bg-[#eef2ff] text-[#5459D1]' : 'text-gray-700 hover:bg-gray-50'"
                    class="text-left px-4 py-2 text-sm transition-colors border-none bg-transparent cursor-pointer !w-full !h-auto">
                    <div class="font-medium">Select Shift</div>
                </button>
                <!-- Real Shifts -->
                <button *ngFor="let shift of shifts" (click)="selectShift(shift); $event.stopPropagation()"
                    [ngClass]="selectedShift?.id === shift?.id ? 'bg-[#eef2ff] text-[#5459D1]' : 'text-gray-700 hover:bg-gray-50'"
                    class="text-left px-4 py-2 text-sm transition-colors border-none bg-transparent cursor-pointer !w-full !h-auto">
                    <div class="font-medium">{{ shift.shift_name }}</div>
                    <div class="text-xs text-gray-500">{{ shift?.start_time }} - {{ shift?.end_time }}</div>
                </button>
            </div>
        </div>
    </div>

    <!-- Shift Info Alert (Hidden when shift selected) -->
    <div *ngIf="!selectedShift"
        class="flex items-center gap-2 p-3 bg-gray-50 border border-solid border-gray-200 rounded-lg">
        <span class="material-symbols-outlined text-gray-400 text-[18px]">error</span>
        <span class="text-sm text-gray-500">Select a shift to apply shift-based work interpretation</span>
    </div>

    <!-- Shift Details Card (Shows when shift selected) -->
    <div *ngIf="selectedShift" class="bg-[#f8f9fb] border border-solid border-[#eef0f2] p-3 rounded-lg animate-fade-in">
        <div class="flex items-center gap-2 mb-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#5459D1]"></span>
            <span class="text-sm font-semibold text-gray-800">{{ selectedShift?.shift_name }}</span>
            <span class="material-symbols-outlined text-gray-400 text-[14px] cursor-help" matTooltipPosition="right"
                matTooltip="Displays currently applied shift configuration affecting report calculations.">info</span>
        </div>
        <div class="text-[11px] text-gray-600 mb-0">
            {{ selectedShift?.start_time }} - {{ selectedShift?.end_time }} • {{
            getFormattedWorkingDays(selectedShift?.working_days) }}
        </div>
        <div class="text-[11px] text-gray-500">
            {{ selectedShift?.strict_window ? 'Strict' : 'Flexible' }}<span *ngIf="selectedShift?.strict_window"> •
                Buffer {{ selectedShift?.buffer_start_minutes || 0 }} min/{{ selectedShift?.buffer_end_minutes || 0 }}
                min</span> • {{ getFormattedTimezone(selectedShift?.timezone) }}
        </div>
    </div>

    <ng-container *ngIf="showDeepWorkSettings">
        <hr class="m-0 border-[0.6px] border-[#e6e6e63b]">

        <div class="flex flex-col gap-4" *ngIf="canUseDeepWorkFilters()">
            <div class="text-gray-600 text-base capitalize mb-1">Deep Work Configuration</div>
            <p class="text-[11px] text-gray-500 m-0">
                Used by the Deep Work tab in Productivity Trends. Apply filters after changing these values.
            </p>

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between gap-2">
                    <div class="flex items-center gap-1">
                        <span class="text-black !text-sm">Minimum session duration</span>
                        <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                            matTooltip="Session length threshold used for deep work analysis in Productivity Trends.">info</span>
                    </div>
                    <span class="text-sm font-semibold text-primary shrink-0">{{ deepWorkDurationLabel() }}</span>
                </div>
                <div class="flex flex-wrap gap-2" role="group" aria-label="Minimum deep work session duration">
                    <button
                        type="button"
                        *ngFor="let opt of deepWorkDurationOptions"
                        (click)="setDeepWorkDuration(opt.value)"
                        [attr.aria-pressed]="deepWorkMinSessionMinutes === opt.value"
                        [ngClass]="deepWorkMinSessionMinutes === opt.value
                          ? 'bg-[#eef2ff] border-primary text-primary shadow-sm'
                          : 'bg-white border-gray-200 text-gray-700 hover:border-primary hover:text-primary'"
                        class="px-3 py-2 rounded-lg border border-solid text-sm font-medium transition-colors outline-none !h-auto cursor-pointer">
                        {{ opt.label }}
                        <span class="text-gray-500 font-normal"> · {{ opt.hint }}</span>
                    </button>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-1">
                        <span class="text-black !text-sm">Min productivity %</span>
                        <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                            matTooltip="Minimum productivity required for a session to be counted as deep work.">info</span>
                    </div>
                    <span class="text-sm font-semibold text-primary">{{ deepWorkMinProductivityPct }}</span>
                </div>
                <input type="range" min="40" max="100" step="1" [(ngModel)]="deepWorkMinProductivityPct" />
            </div>

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-1">
                        <span class="text-black !text-sm">Max distraction %</span>
                        <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                            matTooltip="Maximum distraction allowed for a deep work session.">info</span>
                    </div>
                    <span class="text-sm font-semibold text-primary">{{ deepWorkMaxDistractionPct }}</span>
                </div>
                <input type="range" min="0" max="60" step="1" [(ngModel)]="deepWorkMaxDistractionPct" />
            </div>
        </div>

        <div *ngIf="!canUseDeepWorkFilters()"
            class="flex items-start gap-2 px-3 py-2.5 bg-indigo-50 border border-solid border-indigo-100 rounded-lg">
            <span class="material-symbols-outlined text-indigo-500 text-[18px] shrink-0">lock</span>
            <p class="text-[12px] text-indigo-900 m-0 leading-snug">
                Deep Work session rules are included in Business — unlock the Deep Work tab and customize thresholds there.
            </p>
        </div>
    </ng-container>

    <!-- Advanced Filters Accordion Toggle -->
    <div class="flex items-center mb-1" *ngIf="canUseAdvancedFilters()">
        <button (click)="toggleAdvancedFilter()"
            class="flex items-center gap-2 text-primary font-medium bg-transparent border-none cursor-pointer outline-none p-0 !h-auto">
            <span class="material-symbols-outlined text-[20px] relative top-0">
                {{ isAdvancedFilterOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </span>
            <span class="text-sm">
                {{ isAdvancedFilterOpen ? 'Hide Advanced Filters' : 'Show Advanced Filters' }}
            </span>
        </button>
    </div>

    <!-- Advanced Filters Content -->
    <div *ngIf="canUseAdvancedFilters() && isAdvancedFilterOpen" class="flex flex-col gap-4 animate-fade-in mb-2">
        <hr class="m-0 border-[0.6px] border-[#e6e6e63b]">

        <!-- Quick Presets -->
        <div class="flex flex-col gap-2">
            <div class="text-gray-600 text-base capitalize">
                Quick Presets
            </div>

            <!-- No shift selected warning -->
            <div *ngIf="!selectedShift"
                class="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-solid border-amber-200 rounded-lg">
                <span class="material-symbols-outlined text-amber-500 text-[16px]" matTooltipPosition="right"
                    matTooltip="Select a shift above to enable quick presets">info</span>
                <span class="text-[11px] text-amber-700">Select a shift above to enable quick presets</span>
            </div>

            <div class="flex flex-wrap gap-2 mt-1">
                <button *ngFor="let preset of quickPresets" (click)="selectedShift ? applyQuickPreset(preset.id) : null"
                    [ngClass]="{
                        'bg-[#eef2ff] border-primary text-primary': selectedQuickPreset === preset.id && selectedShift,
                        'bg-white border-gray-200 text-gray-700 hover:border-primary hover:text-primary transition-all': selectedQuickPreset !== preset.id && selectedShift,
                        'bg-gray-50 border-gray-100 text-gray-300 cursor-not-allowed': !selectedShift
                    }" [disabled]="!selectedShift"
                    class="flex items-center gap-2 px-3 py-2 rounded-lg border border-solid !text-sm outline-none !h-auto"
                    [class.cursor-pointer]="selectedShift">
                    <span class="material-symbols-outlined !text-sm">{{ preset.icon }}</span>
                    {{ preset.label }}
                </button>
            </div>
            <p class="text-[11px] text-gray-500 m-0">
                Presets configure the advanced settings below (day selection, time window &amp; interpretation) without
                changing your selected shift or date range.
            </p>
        </div>

        <hr class="m-0 border-[0.6px] border-[#e6e6e63b]">

        <!-- SHIFT & TIME FILTERS -->
        <div class="flex flex-col gap-4">
            <div class="text-gray-600 text-base capitalize mb-1">Shift & Time Filters</div>

            <!-- DAY SELECTION -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1">
                    <span class="text-black !text-sm">Day Selection</span>
                    <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                        matTooltip="Filter report by selected working days.">info</span>
                </div>
                <div class="flex items-center gap-0.5 bg-[#d1d5db38] rounded-lg p-1 w-full">
                    <button (click)="setDaySelection('all')"
                        [ngClass]="selectedDaySelection === 'all' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        All
                    </button>
                    <button (click)="setDaySelection('weekdays')"
                        [ngClass]="selectedDaySelection === 'weekdays' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Weekdays
                    </button>
                    <button (click)="setDaySelection('weekends')"
                        [ngClass]="selectedDaySelection === 'weekends' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Weekends
                    </button>
                    <button (click)="setDaySelection('custom')"
                        [ngClass]="selectedDaySelection === 'custom' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Custom
                    </button>
                </div>

                <!-- Custom Day Picker (Visible when Custom is selected) -->
                <div *ngIf="selectedDaySelection === 'custom'" class="flex items-center gap-1 mt-1 flex-wrap">
                    <button *ngFor="let day of weekDays" (click)="toggleCustomDay(day)"
                        [ngClass]="selectedCustomDays[day] ? 'text-white !shadow-sm !bg-[#5459D1]' : 'bg-gray-50 text-gray-500'"
                        class="flex-1 min-w-[40px] flex items-center justify-center py-2 rounded-md !text-[11px] transition-all cursor-pointer !outline-none !h-auto !border-none">
                        {{ day }}
                    </button>
                </div>
            </div>

            <!-- TIME WINDOW -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1">
                    <span class="text-black !text-sm">Time Window</span>
                    <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                        matTooltip="Limit report data to a specific time range.">info</span>
                </div>
                <div class="flex items-center gap-0.5 bg-[#d1d5db38] rounded-lg p-1 w-full">
                    <button (click)="setTimeWindow(selectedShift ? 'shiftHours' : 'fullDay')"
                        [ngClass]="(selectedTimeWindow === 'fullDay' || selectedTimeWindow === 'shiftHours') ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        {{ selectedShift ? 'Use Shift Hours' : 'Use Full Day' }}
                    </button>
                    <button (click)="setTimeWindow('custom')"
                        [ngClass]="selectedTimeWindow === 'custom' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Custom
                    </button>
                </div>

                <!-- Custom Time Inputs (Aligned with Data Management style) -->
                <div *ngIf="selectedTimeWindow === 'custom'" class="grid grid-cols-2 gap-3 !mt-[12px] animate-fade-in">
                    <mat-form-field appearance="outline" class="w-full compact-time-field"
                        (click)="startTime.showPicker()">
                        <mat-label>Start Time</mat-label>
                        <input #startTime matInput type="time" [(ngModel)]="customStartTime"
                            class="!bg-transparent text-[14px] cursor-pointer">
                        <span matSuffix (click)="$event.stopPropagation(); startTime.showPicker()"
                            class="material-symbols-outlined text-gray-400 text-[18px] mr-2 cursor-pointer">schedule</span>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full compact-time-field"
                        (click)="endTime.showPicker()">
                        <mat-label>End Time</mat-label>
                        <input #endTime matInput type="time" [(ngModel)]="customEndTime"
                            class="!bg-transparent text-[14px] cursor-pointer">
                        <span matSuffix (click)="$event.stopPropagation(); endTime.showPicker()"
                            class="material-symbols-outlined text-gray-400 text-[18px] mr-2 cursor-pointer">schedule</span>
                    </mat-form-field>
                </div>
            </div>

            <!-- WORK INTERPRETATION MODE -->
            <div class="flex flex-col gap-2">
                <div class="flex items-center gap-1">
                    <span class="text-black  !text-sm">Work Interpretation Mode</span>
                    <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                        matTooltip="Strict mode respects shift timings and buffers. Flexible mode includes all activity within selected time window.">info</span>
                </div>
                <div class="flex items-center gap-0.5 bg-[#d1d5db38] rounded-lg p-1 w-full">
                    <button (click)="setInterpretationMode('flexible')"
                        [ngClass]="selectedInterpretationMode === 'flexible' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Flexible
                    </button>
                    <button (click)="setInterpretationMode('strict')"
                        [ngClass]="selectedInterpretationMode === 'strict' ? 'bg-white text-primary shadow-sm' : 'bg-transparent text-gray-600'"
                        class="flex-1 flex items-center justify-center py-1.5 rounded-md !text-sm transition-colors border-none cursor-pointer focus:outline-none !h-auto">
                        Strict
                    </button>
                </div>
            </div>

            <!-- POST SHIFT ANALYSIS WINDOW (Visible for Night Shift + Flexible) -->
            <div *ngIf="selectedInterpretationMode === 'flexible' && isNightShift"
                class="flex flex-col gap-2 animate-fade-in mb-2">
                <div class="flex items-center gap-1">
                    <span class="text-black !text-sm">Post Shift Analysis Window</span>
                    <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                        matTooltip="Additional analysis period after shift end used for night shift insights.">info</span>
                </div>
                <div class="grid grid-cols-2 gap-3 !mt-[12px]">
                    <mat-form-field appearance="outline" class="w-full compact-time-field">
                        <mat-label>Hours (0-12)</mat-label>
                        <input matInput type="number" [(ngModel)]="postShiftAnalysisWindowHours" min="0" max="12"
                            class="!bg-transparent text-[14px]">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-full compact-time-field">
                        <mat-label>Minutes (0-59)</mat-label>
                        <input matInput type="number" [(ngModel)]="postShiftAnalysisWindowMins" min="0" max="59"
                            class="!bg-transparent text-[14px]">
                    </mat-form-field>
                </div>
            </div>

            <!-- BUFFER SETTINGS -->
            <div class="flex flex-col gap-2">
                <!-- Flexible Mode Note (No label shown here) -->
                <div *ngIf="selectedInterpretationMode === 'flexible'"
                    class="text-[11px] text-gray-500 animate-fade-in pl-1">
                    Buffer settings apply only in Strict mode.
                </div>

                <!-- Strict Mode Controls (Label shown here) -->
                <div *ngIf="selectedInterpretationMode === 'strict'" class="flex flex-col gap-2 animate-fade-in">
                    <div class="flex items-center gap-1">
                        <span class="text-gray-400 text-[11px]">Buffer Settings</span>
                        <span class="material-symbols-outlined text-gray-400 text-[14px]" matTooltipPosition="right"
                            matTooltip="Buffer allows grace time before/after shift when evaluating strict work hours.">info</span>
                    </div>

                    <div class="flex items-center gap-2 pl-1 cursor-pointer w-fit" (click)="toggleBufferSetting()">
                        <input type="checkbox"
                            class="!h-[17px] !w-[17px] !text-[#5459D1] !relative !opacity-100 pointer-events-none"
                            [checked]="selectedBufferSetting === 'custom'">
                        <label class="text-sm text-gray-600 pointer-events-none">Custom</label>
                    </div>

                    <!-- Custom Buffer Inputs -->
                    <div *ngIf="selectedBufferSetting === 'custom'"
                        class="grid grid-cols-2 gap-3 !mt-[12px] animate-fade-in">
                        <mat-form-field appearance="outline" class="w-full compact-time-field">
                            <mat-label>Before Buffer (min)</mat-label>
                            <input matInput type="number" [(ngModel)]="beforeBufferTime"
                                class="!bg-transparent text-[14px]">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full compact-time-field">
                            <mat-label>After Buffer (min)</mat-label>
                            <input matInput type="number" [(ngModel)]="afterBufferTime"
                                class="!bg-transparent text-[14px]">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!canUseAdvancedFilters()"
        class="flex items-start gap-2 px-3 py-2.5 bg-indigo-50 border border-solid border-indigo-100 rounded-lg mb-2">
        <span class="material-symbols-outlined text-indigo-500 text-[18px] shrink-0">lock</span>
        <p class="text-[12px] text-indigo-900 m-0 leading-snug">
            Advanced filters (day selection, time windows, quick presets) are included in Professional and above.
        </p>
    </div>

    <!-- Action Buttons -->
    <div class="flex items-center justify-end gap-2 mt-1 pt-4 mb-20 border-t border-gray-200">
        <button (click)="resetFilters()"
            class="px-3 py-2 rounded-md bg-transparent border border-solid border-gray-500 text-gray-700 focus-within:bg-gray-200 focus-within:text-gray-700 !text-sm hover:bg-gray-200 transition-colors cursor-pointer">
            Reset Filter
        </button>
        <button (click)="applyFilters()"
            class="px-3 py-2 rounded-md bg-[#5459D1] text-white focus-within:bg-[#5459D1] focus-within:text-white !text-sm hover:bg-[#3b3f8f] transition-colors border-none cursor-pointer">
            Apply Filter
        </button>
    </div>
</div>